export default {"src":"/_next/static/media/stash_billing-info.4497a86a.svg","height":54,"width":54,"blurWidth":0,"blurHeight":0};